import { seedCatalog } from "../data/seedProduct";
import type { CatalogResponse, CatalogSection, CatalogSectionId } from "../types";

export const catalogSectionDefinitions: ReadonlyArray<Omit<CatalogSection, "items">> = [
  // 2026-08-19: HD画質タグ(ハイビジョン)を除外し、実データで人気の高い
  // コンテンツジャンル「素人」に置換。順序は店舗レイアウト基準。
  { id: "amateur", label: { ja: "素人", en: "Amateur" }, shortLabel: { ja: "素人", en: "AMATEUR" }, accent: "red" },
  { id: "solo", label: { ja: "単体作品", en: "Solo Titles" }, shortLabel: { ja: "単体", en: "SOLO" }, accent: "blue" },
  { id: "exclusive", label: { ja: "独占配信", en: "Exclusive" }, shortLabel: { ja: "独占", en: "EXCLUSIVE" }, accent: "yellow" },
  { id: "creampie", label: { ja: "中出し", en: "Creampie" }, shortLabel: { ja: "中出し", en: "CREAMPIE" }, accent: "red" },
  { id: "big-bust", label: { ja: "巨乳", en: "Big Bust" }, shortLabel: { ja: "巨乳", en: "BUST" }, accent: "blue" },
  { id: "4k", label: { ja: "4K", en: "4K" }, shortLabel: { ja: "4K", en: "4K" }, accent: "yellow" },
  { id: "beautiful", label: { ja: "美少女", en: "Beautiful Girls" }, shortLabel: { ja: "美少女", en: "BEAUTY" }, accent: "red" },
  { id: "married", label: { ja: "人妻・主婦", en: "Married Women" }, shortLabel: { ja: "人妻", en: "MARRIED" }, accent: "blue" },
  // 壁際の棚専用（中央ゴンドラの美少女/人妻と被らないよう別セクション化）
  { id: "mature", label: { ja: "熟女", en: "Mature" }, shortLabel: { ja: "熟女", en: "MATURE" }, accent: "yellow" },
  { id: "best", label: { ja: "ベスト・総集編", en: "Best & Compilation" }, shortLabel: { ja: "総集編", en: "BEST" }, accent: "red" },
];

export async function loadCatalog(
  section: CatalogSectionId = "amateur",
  signal?: AbortSignal,
): Promise<CatalogResponse> {
  try {
    const response = await fetch(`/api/catalog?section=${encodeURIComponent(section)}`, {
      headers: { Accept: "application/json" },
      signal,
    });

    if (!response.ok) {
      throw new Error(`Catalog request failed: ${response.status}`);
    }

    const data = (await response.json()) as CatalogResponse;
    if (!Array.isArray(data.items) || data.items.length === 0) {
      throw new Error("Catalog is empty");
    }
    const items = data.items.filter((item) => isUsableImageUrl(item.images.shelf) && isUsableImageUrl(item.images.detail));
    if (items.length === 0) throw new Error("Catalog has no usable images");
    return { ...data, items };
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      throw error;
    }
    return { ...seedCatalog, section };
  }
}

function isUsableImageUrl(value: string | null): value is string {
  if (!value) return false;
  try {
    const url = new URL(value, window.location.href);
    return url.protocol === "https:" && (url.hostname === "awsimgsrc.dmm.co.jp" || url.hostname === "pics.dmm.co.jp");
  } catch {
    return false;
  }
}

export async function loadStoreCatalog(signal?: AbortSignal): Promise<CatalogSection[]> {
  // Avoid sending all ten catalog requests (and up to thirteen DMM requests)
  // in one burst when the store opens. Small batches are still fast enough to
  // finish during the entrance sequence and are friendlier to the upstream API.
  const responses: CatalogResponse[] = [];
  const batchSize = 3;
  for (let index = 0; index < catalogSectionDefinitions.length; index += batchSize) {
    const batch = catalogSectionDefinitions.slice(index, index + batchSize);
    responses.push(...await Promise.all(batch.map((section) => loadCatalog(section.id, signal))));
  }
  return catalogSectionDefinitions.map((section, index) => ({
    ...section,
    items: responses[index].items,
  }));
}
